import { render, staticRenderFns } from "./ImportErrorList.vue?vue&type=template&id=bc2f58a8&scoped=true&"
import script from "./ImportErrorList.vue?vue&type=script&lang=js&"
export * from "./ImportErrorList.vue?vue&type=script&lang=js&"
import style0 from "./ImportErrorList.vue?vue&type=style&index=0&id=bc2f58a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2f58a8",
  null
  
)

export default component.exports